export const VIEWS = {
  LANDING: "landing",
  WIDGET: "widget-container",
};
